import { Routes } from '@angular/router';
import { exchangeRateResolver } from '@app/resolvers/exchange-rate.resolver';
import { taxGroupResolver } from '@app/resolvers/tax-group.resolver';
import { faBuildingColumns, faCircleEuro, faMessagesDollar, faReceipt } from '@fortawesome/pro-duotone-svg-icons';
import { genericResolver } from '@nittenapps/api';
import { dirtyGuard } from '@nittenapps/common';
import { NavItem } from '@nittenapps/components';

export const FINANCE_ITEMS: NavItem[] = [
  {
    label: 'Finanzas',
    icon: faBuildingColumns,
    iconSet: 'duo',
    roles: ['finance_mngr'],
    children: [
      {
        label: 'Tasas de Cambio',
        icon: faCircleEuro,
        iconSet: 'duo',
        roles: ['finance_mngr'],
        routerLink: ['finance', 'exchange-rates'],
      },
      {
        label: 'Grupos de Impuestos',
        icon: faMessagesDollar,
        iconSet: 'duo',
        roles: ['finance_mngr'],
        routerLink: ['finance', 'tax-groups'],
      },
      {
        label: 'Administración de Conceptos',
        icon: faReceipt,
        iconSet: 'duo',
        roles: ['finance_mngr'],
        routerLink: ['finance', 'concepts'],
      },
    ],
  },
];

export const ROUTES: Routes = [
  {
    path: 'concepts',
    loadComponent: () => import('@nittenapps/activity').then((m) => m.ActivityComponent),
    data: {
      breadcrumb: 'Administración de Conceptos',
      roles: ['finance_mngr'],
    },
    children: [
      {
        path: '',
        loadComponent: () => import('./concepts/list/list.component').then((m) => m.ListComponent),
      },
      {
        path: ':id',
        loadComponent: () => import('./concepts/detail/detail.component').then((m) => m.DetailComponent),
        canDeactivate: [dirtyGuard],
        resolve: { model: genericResolver },
        data: {
          breadcrumb: { disabled: true, label: (data: any) => `${data.model?.name || 'Nuevo'}` },
        },
      },
    ],
  },
  {
    path: 'exchange-rates',
    loadComponent: () => import('@nittenapps/activity').then((m) => m.ActivityComponent),
    data: {
      breadcrumb: 'Tasas de Cambio',
      roles: ['finance_mngr'],
    },
    children: [
      {
        path: '',
        loadComponent: () => import('./exchange-rates/list/list.component').then((m) => m.ListComponent),
      },
      {
        path: ':id',
        loadComponent: () => import('./exchange-rates/detail/detail.component').then((m) => m.DetailComponent),
        canDeactivate: [dirtyGuard],
        resolve: { model: exchangeRateResolver },
        data: {
          breadcrumb: { disabled: true, label: (data: any) => `${data.model?.currency?.name || 'Nuevo'}` },
        },
      },
    ],
  },
  {
    path: 'tax-groups',
    loadComponent: () => import('@nittenapps/activity').then((m) => m.ActivityComponent),
    data: {
      breadcrumb: 'Grupos de Impuestos',
      roles: ['finance_mngr'],
    },
    children: [
      {
        path: '',
        loadComponent: () => import('./tax-groups/list/list.component').then((m) => m.ListComponent),
      },
      {
        path: ':id',
        loadComponent: () => import('./tax-groups/detail/detail.component').then((m) => m.DetailComponent),
        canDeactivate: [dirtyGuard],
        resolve: { model: taxGroupResolver },
        data: {
          breadcrumb: { disabled: true, label: (data: any) => `${data.model?.group?.name || 'Nuevo'}` },
        },
      },
    ],
  },
];
